import * as Sentry from "@sentry/react";
Sentry.init({
  dsn: "https://cf9ede511b938f2bcd9f1c80d3bca7eb@o4510464408813568.ingest.de.sentry.io/4510580558463056",
  release: import.meta.env.VITE_SENTRY_RELEASE,
  environment: import.meta.env.MODE,
  enabled: !import.meta.env.DEV,
  debug: import.meta.env.DEV,
  sendDefaultPii: true,
});

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./i18n";
import "./index.css";
import App from "./App.tsx";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
